import { CoreUiException } from "./core-ui-exception";

/**
 * The control state is invalid
 */
export class InvalidControlStateException extends CoreUiException {

    constructor(message: string, originalError?: any) {

        super("InvalidControlStateException", message, originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, InvalidControlStateException.prototype);
    }
}
